module.exports = __webpack_public_path__ + "img/o.92817277.png";